import { inlineSvgMapping } from './inline-svg';

export function hasSvgMapping(id: string): boolean {
  return id in inlineSvgMapping;
}
